// export loan slider module
export { TNKLoanSliderModule } from './src/app/components/loan-slider/loan-slider.module';
export { TNKLoanSliderComponent } from './src/app/components/loan-slider/loan-slider.component';

// export auth component module
export { TNKAuthCustomerModule } from './src/app/components/auth-customer/auth-customer.module';
export { TNKAuthCustomerComponent } from './src/app/components/auth-customer/auth-customer.component';

// export survey component module
export { TNKSurveyModule } from './src/app/components/survey/survey.module';
export { TNKSurveyComponent } from './src/app/components/survey/survey.component';

// export digital contract component module
export { TNKDigitalContractComponent } from './src/app/components/digital-contract/digital-contract.component';
export { TNKDigitalContractModule } from './src/app/components/digital-contract/digital-contract.module';

// export authenticated slider module (for second-loan and topup)
export { TNKAuthLoanSliderModule } from './src/app/components/auth-loan-slider/auth-loan-slider.module';
export { TNKAuthLoanSliderComponent } from './src/app/components/auth-loan-slider/auth-loan-slider.component';

// export authenticated form module (for second-loan and topup review section)
export { TNKAuthLoanFormModule } from './src/app/forms/auth-loan-form/auth-loan-form.module';
export { TNKAuthLoanFormComponent } from './src/app/forms/auth-loan-form/auth-loan-form.component';
export { TNKAuthLoanFormService } from './src/app/forms/auth-loan-form/auth-loan-form.service';

// export date dropdown module
export { TNKDateDropdownModule } from './src/app/components/date-dropdown/date-dropdown.module';
export { TNKDateDropdownComponent } from './src/app/components/date-dropdown/date-dropdown.component';

// export utilities
export { TNKUtilitiesModule } from './src/app/utils/utilities.module';

// export validators
export { NumericalValidator } from './src/app/validator/numerical/numerical.validator';
export { RequiredSelectValidator } from './src/app/validator/required-select/required-select.validator';
export { AlphaNumericalValidator } from './src/app/validator/alphanumeric/alpha-numeric.validator';

//export b2b loan slider and form module
export { B2BTNKLoanSliderModule } from './src/app/components/b2b-loan-slider/b2b-loan-slider.module';
export { B2BTNKLoanFormModule } from './src/app/forms/b2b-loan-form/b2b-loan-form.module';
export { B2BTNKLoanFormService } from './src/app/forms/b2b-loan-form/b2b-loan-form.service';

//export b2b loan slider and form component
export { B2BTNKLoanFormComponent } from './src/app/forms/b2b-loan-form/b2b-loan-form.component';
export { B2BTNKLoanSliderComponent } from './src/app/components/b2b-loan-slider/b2b-loan-slider.component';

//export confirmation form component
export { ConfirmationFormComponent } from './src/app/forms/confirmation-form/confirmation-form.component';
export { TNKConfirmationFormModule } from './src/app/forms/confirmation-form/confirmation-form.module';

export { FeedbackJourneyModule } from './src/app/components/feedback-journey/feedback-journey.module';
